import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  // Link,
  // useRouteMatch,
  // useParams
} from "react-router-dom";
import HomePage from './pages/HomePage/index.js';
import Dashboard from './pages/Dashboard/index.js';
import TestPage from './pages/TestPage/index.js'
import Result from './pages/Result/index.js';
import NotFound  from "./pages/NotFound.js";
import About from './pages/About/About';
import Contact from './pages/Contact/Contact.js';
import Footer from './pages/Footer/index.js'
function App() {
  return (
    <div className="App">
      <Router>
        <HomePage />
        <Switch>
          <Route exact path="/" component={About} />
          <Route exact path="/papers" component={Dashboard} />
          <Route exact path="/testpage/:id" component={TestPage} />
          <Route exact path="/result/:id" component={Result} />
          <Route exact path="/contact" component={Contact} />
          <Route path="/404" component={NotFound} />
          <Redirect to = "/404"/>
        </Switch>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
